'use client';
import type { JSX } from 'react';

export type ProbabilityBarPieceVariant = 'neutral' | 'red' | 'blue' | 'purple';

interface ProbabilityBarPieceProps {
    variant: ProbabilityBarPieceVariant;
}

const ProbabilityBarPiece = ({ variant }: ProbabilityBarPieceProps): JSX.Element => {
    const baseClasses = 'h-5 rounded-x20 w-full border transition-colors duration-200';
    const variantClasses = {
        neutral: 'bg-fill-x40 group-hover:bg-fill-x50 group-hover:border-fill-x10 group-hover:border-solid',
        red: 'bg-red-x30 group-hover:bg-red-x20 group-hover:border-red-x40 group-hover:border-solid',
        blue: 'bg-blue-x30 group-hover:bg-blue-x20 group-hover:border-blue-x40 group-hover:border-solid',
        purple: 'bg-purple-x30 group-hover:bg-purple-x20 group-hover:border-purple-x40 group-hover:border-solid',
    };

    return <div className={`${baseClasses} ${variantClasses[variant]}`} />;
};

export default ProbabilityBarPiece;
